import { render, staticRenderFns } from "./CourseTab.vue?vue&type=template&id=4853d00e&scoped=true&"
import script from "./CourseTab.vue?vue&type=script&lang=js&"
export * from "./CourseTab.vue?vue&type=script&lang=js&"
import style0 from "./CourseTab.vue?vue&type=style&index=0&id=4853d00e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4853d00e",
  null
  
)

export default component.exports